import script from "./locus-info.vue?vue&type=script&lang=ts&setup=true"
export * from "./locus-info.vue?vue&type=script&lang=ts&setup=true"

import "./locus-info.vue?vue&type=style&index=0&id=12df0759&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12df0759"]])

export default __exports__